export default __webpack_public_path__ + "static/media/flowers.991e530b.png";